/*
 * HARRY-Port C / Ebene 2 — hält die Theme-Checkout-Sperre nach AJAX-Warenkorb-
 * Änderungen aktuell.
 *
 * Dawn rendert weder den Checkout-Button-Block im Warenkorb-Footer noch die
 * Buttons in der Warenkorb-Benachrichtigung bei einer Mengenänderung neu.
 * Liquid setzt den Anfangszustand, dieses Script hält ihn per `cart-update`-
 * Event in Sync. Die Function (App lb-min-order) bleibt der serverseitige
 * Backstop.
 *
 * Erwartet Container mit [data-min-order-cents]; darin:
 *   - button[name="checkout"] bzw. .cart__checkout-button  -> disabled
 *   - .cart__minimum-note                                   -> hidden toggeln
 *   - benachbarte .cart__dynamic-checkout-buttons           -> hidden toggeln
 */
(function () {
  if (window.__cartMinGateInit) return;
  window.__cartMinGateInit = true;

  function apply(totalCents) {
    if (typeof totalCents !== 'number') return;
    document.querySelectorAll('[data-min-order-cents]').forEach(function (box) {
      var min = parseInt(box.dataset.minOrderCents, 10) || 0;
      var below = min > 0 && totalCents > 0 && totalCents < min;

      box.querySelectorAll('button[name="checkout"], .cart__checkout-button').forEach(function (btn) {
        btn.disabled = below || totalCents === 0;
      });

      var note = box.querySelector('.cart__minimum-note');
      if (note) note.hidden = !below;

      var parent = box.parentElement;
      var dyn = parent && parent.querySelector('.cart__dynamic-checkout-buttons');
      if (dyn) dyn.hidden = below;
    });
  }

  function refetch() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { apply(c.total_price); })
      .catch(function () {});
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var total = event && event.cartData && typeof event.cartData.total_price === 'number'
        ? event.cartData.total_price
        : null;
      if (total !== null) apply(total);
      else refetch();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
